export default __webpack_public_path__ + "static/media/F1_8.f4741458.png";